import {BaseModel} from "../../../../../infrastructure/models/base-model";
import type {ImageRequestParams} from "../../../../../infrastructure/models/params/image-request-params";

export class FooterModuleCountryComplianceModel extends BaseModel {
  url: String;
  image: ImageRequestParams;

  constructor(url: String, image: ImageRequestParams, imageHeight) {
    super();

    this.url = url;
    this.image = image;
    this.imageHeight = imageHeight;
  }
}
